/**
 * Generates the chat file download url given the file's uuid.
 *
 * @param apiBasePath The app's apiBasePath.
 * @param roomUrn The current room urn.
 * @param fileUuid The file uuid.
 */
export function fromFileUuidToUrl(apiBasePath: string, roomUrn: string, roomType: string, fileUuid: string) {
    const url = `${apiBasePath}/v1/rooms/${roomUrn}/uploadedfiles/${fileUuid}?roomType=${roomType}`
    return url
}

/**
 * Extracts the file uuid from the given url. This is essentially the inverse operation of the
 * `fromFileUuidToUrl` function.
 * @param url The url to extract the file uuid from.
 */
export function fromUrlToFileUuid(url: string) {
    const tokens = url.split('/')
    if (tokens.length > 0) {
        const fileUuid = decodeURIComponent(tokens[tokens.length - 1].split('?')[0])
        return fileUuid
    } else {
        return ''
    }
}
